// @flow

import { type CardBrand } from './types';

type CardBrandPattern = {|
  brand: CardBrand,
  pattern: RegExp,
|};

const patterns: ImmutableArray<CardBrandPattern> = [
  { brand: 'visa', pattern: /^4/ },
  { brand: 'mastercard', pattern: /^(5[1-5]|677189)|^(222[1-9]|2[3-6]\d{2}|27[0-1]\d|2720)/ },
  { brand: 'carnet', pattern: /^(286900|502275|506(199|2(0[1-6]|1[2-578]|2[289]|3[67]|4[579]|5[0-57-9]|6[1-79]|7[02-9]|8[0-8]|9[234679])|3(0[0-9]|1[1-479]|2[0239]|3[02-79]|4[0-49]|5[0-79]|6[014-79]|7[0-49]|8[0-467]|9[124])|402)|588772(2|02|66|67|68|74|84)|6046220[34]|604622(69|3|4)|606333|63(6379|9(388|484|559)))/ },
  { brand: 'amex', pattern: /^3[47]/ },
  { brand: 'diners', pattern: /^(36|38|30[0-5])/ },
  { brand: 'discover', pattern: /^(6011|65|64[4-9]|622)/ },
  { brand: 'elo', pattern: /^(4011|438935|45(1416|76|7393)|50(4175|6699|67|90[4-7])|63(6297|6368))/ },
  { brand: 'hipercard', pattern: /^(606282\d{10}(\d{3})?)|(3841\d{15})/ },
  { brand: 'naranja', pattern: /^(589562|402917|402918|527571|527572|0377798|0377799)/ },
];

export function detectCardBrand(value: string): ?CardBrand {
  const pattern = patterns.find(item => item.pattern.test(value));
  if (pattern) {
    return pattern.brand;
  }
  return null;
}
